import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import i18next from "i18next";
import { tabsNames } from "../../utils/constants";
import LeaderboardParticipantsTable from "./LeaderboardParticipantsTable";
import LeaderboardTableRows from "./LeaderboardTableRows";
import { FC } from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { LeaderboardProps } from "../../types/props/leaderboardUiProps";
import { Box, Callout, Text, Tabs } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

export const LeaderboardUI: FC<LeaderboardProps> = ({
  selectedFilterType,
  setPropsFilters,
  currentUserInThisChallenge,
  // _loading,
  leaderboardData,
  // participants,
  inViewRefElementIndex,
  loading,
  game,
  isUserParticipated,
  MemoizedCurrUser,
  maxItems,
}) => {
  const currentUser = useCurrentUserProfile((s) => s.user);

  const hasSocialFeatures = brand.hasFeature.friends;

  const filteredParticipants = leaderboardData.filter(
    (participant) => participant.userChallengeData.points !== 0
  );

  // Check if any of the user's data is not loaded,
  // if so, show only the filtered participants from Firestore DB, where all data is available.
  const firestoreLeaderboardData = leaderboardData.some(
    (item) => item.profile.userName === "Failed to load user's info"
  )
    ? filteredParticipants
    : leaderboardData;

  const currentUserChallData = currentUserInThisChallenge?.userChallengeData;

  return (
    <>
      <Box>
        {!currentUserChallData && (
          <Box mb="3">
            <Text size="3">
              {i18next.t("challenge.leaderboard.score.description")}
            </Text>
          </Box>
        )}
        {currentUserChallData && isUserParticipated && (
          <Box mb="3">
            <Box>
              <Text size="3" weight="medium">
                {i18next.t("challenge.leaderboard.score.yours")}
              </Text>
              <LeaderboardTableRows
                rank={
                  currentUserChallData?.points == 0
                    ? "-"
                    : currentUserChallData?.rank
                }
                logo={currentUser.profileLogoUrl}
                name={[currentUser.userName, currentUser.fullName]}
                points={
                  currentUserChallData?.points == 0
                    ? "-"
                    : currentUserChallData?.points
                }
                slug={currentUser.slug}
                game={game}
                pointsType={
                  currentUserInThisChallenge?.userChallengeData?.pointsType
                }
              />
            </Box>
          </Box>
        )}

        <Tabs.Root defaultValue={selectedFilterType}>
          {!brand.event.isEvent && hasSocialFeatures && (
            <Tabs.List mb="2">
              {tabsNames.map((tabName) => (
                <Tabs.Trigger
                  key={tabName}
                  value={tabName}
                  onClick={() => setPropsFilters(tabName)}
                >
                  {i18next.t(`challenge.leaderboard.tabs.${tabName}`)}
                </Tabs.Trigger>
              ))}
            </Tabs.List>
          )}

          <Tabs.Content value={selectedFilterType}>
            <Text size="3" weight="medium">
              Results
            </Text>
            <LeaderboardParticipantsTable
              items={firestoreLeaderboardData}
              inViewIndex={inViewRefElementIndex}
              loading={loading || loading}
              game={game}
              maxItems={maxItems}
            >
              <Callout.Root>
                <Callout.Icon>
                  <InfoCircledIcon />
                </Callout.Icon>
                <Callout.Text>
                  {!loading &&
                    selectedFilterType === "ALL" &&
                    i18next.t("challenge.leaderboard.score.noParticipants")}
                  {!loading &&
                    selectedFilterType === "FRIENDS" &&
                    i18next.t("challenge.leaderboard.score.noFriends")}
                  {!loading &&
                    selectedFilterType === "FOLLOWING" &&
                    i18next.t("challenge.leaderboard.score.noFollowing")}
                </Callout.Text>
              </Callout.Root>
            </LeaderboardParticipantsTable>
          </Tabs.Content>
        </Tabs.Root>
      </Box>
    </>
  );
};
